import { cloneObject, wrap } from "../utils/utils";
import JSZip from "jszip";

import dsd from "../classes/clsDSD";


export const addCodeList = (dsd, Data = {}, onAdd, onError) => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    let payload = payloadCodeList(Data);

    dsd.httpConfig.post(`/codelists`, payload, headers)
        .then(response => { if (onAdd) { onAdd(response.data._id); } })
        .catch(e => { if (onError) { onError(e); } });

    return;
};


export const editCodeList = (dsd, id = null, Data = {}, onUpdate, onError) => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    let payload = payloadCodeList(Data);

    dsd.httpConfig.put(`/codelists/${id}`, payload, headers)
        .then(() => { if (onUpdate) { onUpdate(); } })
        .catch(e => { if (onError) { onError(e); } });

    return true;
};


function payloadCodeList(data) {
    return {
        name: data.name,
        description: data.description,
        namespace: data.namespace,
        prefix: data.prefix,
        proposals: data.proposals,
        status: data.status,
    };
}


export const listCodeLists = (dsd, Filters = {}, onLoad, onError) => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    let urlAPI = "/codelists";
    if (Object.keys(Filters).length > 0) { urlAPI += "?"; }

    if (Filters.idUser)  { urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`; }
    if (Filters.scope)   { urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`; }
    if (Filters.status)  { urlAPI += `status=${encodeURIComponent(Filters.status)}&`; }
    if (Filters.search)  { urlAPI += `search=${encodeURIComponent(Filters.search)}&`; }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = response.data.map(item => dataCodeList(item));
            if (onLoad) { onLoad(arr); }
        })
        .catch(e => { if (onError) { onError(e); } });

    return;
};


export const getCodeList = (dsd, id = null, onLoad = null, onFail = null, format = 'dsd') => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    if (!id) { if (onFail) { onFail(new Error("No id supplied")); } return; }

    let URL = `/codelists/${id}`;
    if (format && format !== 'dsd') {
        URL += `?format=${format}`;
    }

    dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (format && format !== 'dsd') {
                if (onLoad) { onLoad(response.data); }
            } else {
                if (onLoad) { onLoad(dataCodeList(response.data)); }
            }
        })
        .catch(e => { if (onFail) { onFail(e); } });

    return;
};


function dataCodeList(data) {
    return data;
}


export const addItemToCodeList = (dsd, idCodeList, Data = {}, onAdd, onError) => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    let payload = payloadItem(Data);

    dsd.httpConfig.post(`/codelists/${idCodeList}/items`, payload, headers)
        .then(response => { if (onAdd) { onAdd(response.data._id); } })
        .catch(e => { if (onError) { onError(e); } });

};


export const editItem = (dsd, id = null, Data = {}, onUpdate, onError) => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    let payload = payloadItem(Data);
    let idCodeList = null;
    if (Data.CodeList) { idCodeList = Data.CodeList._id; }

    dsd.httpConfig.put(`/codelists/${idCodeList}/items/${id}`, payload, headers)
        .then(() => { if (onUpdate) { onUpdate(); } })
        .catch(e => { if (onError) { onError(e); } });

};


export const getItem = (dsd, id = null, onLoad = null, onFail = null, format = 'dsd') => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    if (!id) { if (onFail) { onFail(new Error("No id supplied")); } return; }

    let URL = `/items/${id}`;
    if (format && format !== 'dsd') {
        URL += `?format=${format}`;
    }

    dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (format && format !== 'dsd') {
                if (onLoad) { onLoad(response.data); }
            } else {
                if (onLoad) { onLoad(response.data); }
            }
        })
        .catch(e => { if (onFail) { onFail(e); } });

    return;
};


export const listItems = (dsd, Filters = {}, onLoad, onError) => {

    let headers = { headers: { "Content-type": "application/json" } };
    let authHeader = dsd.authHeader();
    if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

    let urlAPI = "/items";
    if (Object.keys(Filters).length > 0) { urlAPI += "?"; }

    if (Filters.idCodeList) { urlAPI += `idCodeList=${encodeURIComponent(Filters.idCodeList)}&`; }
    if (Filters.status)     { urlAPI += `status=${encodeURIComponent(Filters.status)}&`; }
    if (Filters.search)     { urlAPI += `search=${encodeURIComponent(Filters.search)}&`; }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => { if (onLoad) { onLoad(response.data); } })
        .catch(e => { if (onError) { onError(e); } });

    return;
};


function payloadItem(data) {
    return {
        code: data.code,
        label: data.label,
        definition: data.definition,
        usageNotes: data.usageNotes,
        status: data.status || 'in use',
        Parents: data.Parents || [],
    };
}

export const getCodeListVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/codelists/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const zipCodeList = async function(dsd, id, idVersion){

    const zip = new JSZip();

    const assets = await assetsCodeListVersion(dsd, id, idVersion);

    const CodeList = assets["dsd.json"];

    let nameFolder = `codelist_${id}`;
    if (idVersion){
        nameFolder += `_version_${idVersion}`;
    }

    for (const idAsset in assets){
        let assetValue = assets[idAsset];

        // Serialize JSON-like objects before zipping.
        if (
            typeof assetValue === 'object' &&
            assetValue !== null &&
            !(assetValue instanceof Blob) &&
            !(assetValue instanceof ArrayBuffer) &&
            !(assetValue instanceof Uint8Array)
        ) {
            assetValue = JSON.stringify(assetValue, null, 4);
        }

        zip.file(`${nameFolder}/${idAsset}`, assetValue);

// repeat for /site and /siteGDS

        if (idAsset.startsWith("site/") || idAsset.startsWith("siteGDS/")) {
            continue;
        }

        switch (idAsset) {
            case "page.md":
            case "index.html":
            case "indexGDS.html":
                break; // Skip these files for /site and /siteGDS
            default:{
                zip.file(`${nameFolder}/site/${idAsset}`, assetValue);
                zip.file(`${nameFolder}/siteGDS/${idAsset}`, assetValue);
            }
        }
    }

    const zipData = await zip.generateAsync({
        type: "blob",
        streamFiles: true,
    });

    return zipData;

};

export const assetsCodeListVersion = async function(dsd, idCodeList, idVersion){

    const assets = {};

    let Promises = [];

    let doc = null;
    let page = null;
    let index = null;
    let indexGDS = null;

    let site = null;
    let siteGDS = null;


    let csv = null;
    let skos_turtle = null;
    let skos_jsonld = null;
    let owl_turtle = null;
    let owl_jsonld = null;

    let CodeList = null


    const onDoneDoc = function(reply){
        doc = reply;
        return;
    };


    const onDonePage = function(reply){
        page = reply;
        return;
    };


    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };



    const onDoneCsv = function(reply){
        csv = reply;
        return;
    };

    const onDoneSkos_turtle = function(reply){
        skos_turtle = reply;
        return;
    };

    const onDoneSkos_jsonld = function(reply){
        skos_jsonld = reply;
        return;
    };

    const onDoneOwl_turtle = function(reply){
        owl_turtle = reply;
        return;
    };

    const onDoneOwl_jsonld = function(reply){
        owl_jsonld = reply;
        return;
    };

    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneDoc));
    
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDonePage, null,'page'));
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneIndex, null,'page', 'html'));

    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));


    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneCsv, null,'csv'));
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneSkos_turtle, null,'skos', 'turtle'));
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneSkos_jsonld, null,'skos', 'jsonld'));
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneOwl_turtle, null,'owl', 'turtle'));
    Promises.push(getCodeListVersion(dsd,idCodeList,idVersion, onDoneOwl_jsonld, null,'owl', 'jsonld'));



    return(
        Promise.all(Promises)
        .then(async response => {

            if (doc){
                assets["dsd.json"] = doc;
                CodeList = cloneObject(doc);
            }

            if (page){
                assets["page.md"] = page;
            }
            if (index){
                assets["index.html"] = index;
            }
            
            if (indexGDS){
                assets["indexGDS.html"] = indexGDS;
            }


            if (csv){
                assets["codelist.csv"] = csv;
            }
            if (skos_turtle){
                assets["skos.ttl"] = skos_turtle;
            }
            if (skos_jsonld){
                assets["skos.jsonld"] = skos_jsonld;
            }

            if (owl_turtle){
                assets["owl.ttl"] = owl_turtle;
            }
            if (owl_jsonld){
                assets["owl.jsonld"] = owl_jsonld;
            }

            if (site && Array.isArray(site.files)){
                for (const file of site.files){
                    if (file.content != null){
                        assets[`site/${file.path}`] = file.content;
                    }
                }
            }

            if (siteGDS && Array.isArray(siteGDS.files)){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        assets[`siteGDS/${file.path}`] = file.content;
                    }
                }
            }

            return assets;    

        })
    )

};
